import React from 'react'
import { buildOrderQuery } from './graphql'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'

export const OrderInlineInput = ({
  parentInputComponent,
  name,
  mutationConfig,
  query,
  ...rest
}: InlineInputProps & { query?: string }) => {
  const ParentInput = parentInputComponent || InlineInput

  const defaultMutationConfig = React.useMemo(() => {
    if (query) return buildOrderQuery(query).updateConfig

    return buildOrderQuery(name).updateConfig
  }, [name, query])

  return <ParentInput {...{ name, mutationConfig: mutationConfig ?? defaultMutationConfig, ...rest }} />
}
